export default (theme) => ({
  dashboard: {
    minHeight: "calc(100vh - 40px)",
    width: "calc(100vw - 40px)",
    padding: 20,
  },
});
